'use client';

import { useActionTrigger } from '@/hooks/useAction';
import { Button } from '@/ui/Button';
import { Icon } from '@/ui/Icon';

export function ViewConfigButton() {
    const handleClick = useActionTrigger('__open_dev_config');

    return (
        <Button
            className="px-3 py-0 text-xs max-md:w-md max-md:p-0"
            onClick={() => handleClick()}
        >
            <Icon className="text-2xl">settings</Icon>
            <span className="py-2 max-md:hidden">View Config</span>
        </Button>
    );
}
